// extracted by mini-css-extract-plugin
export default {"headerRow":"SimpleTabs_headerRow__ghp9X","customNavTabs":"SimpleTabs_customNavTabs__ay4EZ"};